import { Box, Typography, TextField, Button } from "@mui/material";
import React from "react";

export const Step5 = (props) => {
  const {
    register,
    errors,
    calculateTotalFileSize,
    setUploadedAditionalFiles,
    uploadedAditionalFiles,
  } = props;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">Daños de la edificación</Typography>
      <Typography variant="p">
        Por favor, indique el área afectada, tipo de daño y detalles relevantes.
      </Typography>

      <TextField
        {...register("damageEdificacion", {
          required: "El campo es obligatorio",
        })}
        label="Describa los daños por estancia."
        placeholder={`Ej: Dormitorio 1, parquet levantado, desprendimiento de zócalos, etc.\n     Cocina, roturas en pared, alicatado roto, etc.`}
        fullWidth
        required
        multiline
        minRows={4}
        sx={{ mb: 2, mt: 2 }}
        error={!!errors.damageEdificacion}
        helperText={errors.damageEdificacion?.message}
      />
      <Typography variant="subtitle1">
        Sube documentos, fotos o videos
      </Typography>
      <Typography
        variant="body2"
        color={
          calculateTotalFileSize() > 24 * 1024 * 1024 ? "error" : "inherit"
        }
      >
        Tamaño total:{" "}
        {Math.round((calculateTotalFileSize() / 1024 / 1024) * 100) / 100} MB /
        25 MB
      </Typography>
      <Button variant="outlined" component="label" fullWidth sx={{ mb: 2 }}>
        Seleccionar archivos
        <input
          type="file"
          hidden
          multiple
          accept="image/*, video/*, application/pdf"
          onChange={(e) => {
            const newFiles = Array.from(e.target.files);
            setUploadedAditionalFiles((prevFiles) => [
              ...prevFiles,
              ...newFiles,
            ]);
          }}
        />
      </Button>

      {uploadedAditionalFiles.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2">Archivos seleccionados:</Typography>
          <ul>
            {uploadedAditionalFiles.map((file, index) => (
              <li key={index}>
                {file.name}
                <Button
                  variant="text"
                  color="error"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    setUploadedAditionalFiles((prevFiles) =>
                      prevFiles.filter((_, i) => i !== index)
                    );
                  }}
                >
                  ✖︎ Eliminar
                </Button>
              </li>
            ))}
          </ul>
        </Box>
      )}
    </Box>
  );
};

export default Step5;
